import { ReactComponent as AndroidIcon } from 'img/indexAppDownload/android.svg';
import { ReactComponent as AppleIcon } from 'img/indexAppDownload/apple.svg';

const Button = ({ children, android, apple, onClick }) => {
  const handleClick = () => {
    onClick?.();
  };

  return (
    <button className="downloadButtonWrapper" onClick={handleClick}>
      <div className="downloadButtonContainer">
        {android && <AndroidIcon />}
        {apple && <AppleIcon />}
        {children}
      </div>
    </button>
  );
};

export default Button;
